const STORAGE_KEY = 'sbn:queryNumberInSession';

function safeStorage(): Storage | null {
  try {
    // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    // sessionStorage access can throw in strict privacy modes.
    return null;
  }
}

export function getQueryNumberInSession(): number {
  const storage = safeStorage();
  if (!storage) return 0;
  const raw = storage.getItem(STORAGE_KEY);
  const parsed = raw ? parseInt(raw, 10) : 0;
  return Number.isFinite(parsed) ? parsed : 0;
}

export function incrementQueryNumberInSession(): number {
  const storage = safeStorage();
  const next = getQueryNumberInSession() + 1;
  if (storage) storage.setItem(STORAGE_KEY, String(next));
  return next;
}
